import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("mdi-file-pdf")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("mdi-eye-off")
const _hoisted_3 = {
  key: 12,
  class: "text-wrap",
  style: {"max-width":"250px"}
}
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TDialogPersonPicture = _resolveComponent("TDialogPersonPicture")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_MListEntity = _resolveComponent("MListEntity")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_AButtonIcon = _resolveComponent("AButtonIcon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_hover = _resolveComponent("v-hover")!

  return (_openBlock(), _createBlock(_component_v_hover, null, {
    default: _withCtx(({ props }) => [
      _createElementVNode("span", _mergeProps(props, { style: {"width":"100%"} }), [
        (_ctx.cellField === 'main_picture_preview')
          ? (_openBlock(), _createBlock(_component_TDialogPersonPicture, {
              key: 0,
              item: _ctx.item
            }, null, 8, ["item"]))
          : (_ctx.cellField === 'password')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.item[_ctx.cellField] ? '******' : ''), 1)
              ], 64))
            : (_ctx.cellField === 'is_warehouse_evaluation_completed')
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 2,
                  location: "bottom"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_icon, _mergeProps(props, {
                      color: _ctx.value ? 'primary' : 'secondary',
                      icon: _ctx.value ? _ctx.icons['filePDF'] : _ctx.icons['filePending'],
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openWarehouseEvaluationPDF()))
                    }), null, 16, ["color", "icon"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_ctx.UTIL.valuesTranslation(_ctx.cellField, _ctx.value)), 1)
                  ]),
                  _: 2
                }, 1024))
              : (_ctx.datetimeKeys.includes(_ctx.cellField))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode(_toDisplayString(_ctx.UTIL.formatDateLong(_ctx.item[_ctx.cellField])), 1)
                  ], 64))
                : (['persons_count', 'groups_count'].includes(_ctx.cellField))
                  ? (_openBlock(), _createBlock(_component_MListEntity, {
                      key: 4,
                      item: _ctx.item,
                      "key-name": _ctx.cellField,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editItem($event)))
                    }, null, 8, ["item", "key-name"]))
                  : (_ctx.cellField === 'person_record_at')
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 5,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            style: {"height":"14px !important","overflow-y":"hidden"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                class: "mr-2",
                                icon: _ctx.icons['arrowRight']
                              }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.UTIL.formatDateLong(_ctx.item.first_person_record_at)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            style: {"height":"14px !important","overflow-y":"hidden"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                class: "mr-2",
                                icon: _ctx.icons['arrowLeft']
                              }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.UTIL.formatDateLong(_ctx.item.last_person_record_at)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_ctx.cellField === 'person_record_loc')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                          (_ctx.item.first_person_record)
                            ? (_openBlock(), _createBlock(_component_AButtonIcon, {
                                key: 0,
                                icon: _ctx.icons['googleMaps'],
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openGoogleMaps(_ctx.item.first_person_record.coordinates)))
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true),
                          (_ctx.item.last_person_record_loc)
                            ? (_openBlock(), _createBlock(_component_AButtonIcon, {
                                key: 1,
                                icon: _ctx.icons['googleMaps'],
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openGoogleMaps(_ctx.item.last_person_record_loc.coordinates)))
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_ctx.isKeyToParse)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 7 }, _renderList(_ctx.valueParsed, (e, idx) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (idx < 3)
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    class: "my-1 mr-1",
                                    label: "",
                                    small: "",
                                    light: "",
                                    key: e.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.UTIL.valuesTranslation(_ctx.cellField, e)), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (idx === 3)
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    class: "mb-1",
                                    label: "",
                                    small: "",
                                    light: "",
                                    key: e.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString('+' + (_ctx.value.length - 3) + ' ' + _ctx.$t('General_others')), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        : (_ctx.cellField === 'observations_menu')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                              _createTextVNode(_toDisplayString(_ctx.menuItems[_ctx.value]), 1)
                            ], 64))
                          : (_ctx.cellField === 'observations_value')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                _createTextVNode(_toDisplayString(_ctx.UTIL.formatTableValue(_ctx.item['observations_submenu'], _ctx.value)), 1)
                              ], 64))
                            : (_ctx.isURL)
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 10,
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openPDF(_ctx.value)))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_1
                                  ]),
                                  _: 1
                                }))
                              : (Array.isArray(_ctx.value))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (element, idx) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        ((_ctx.isCellEditor ? idx < 1 : idx < 3) || _ctx.state.show)
                                          ? (_openBlock(), _createBlock(_component_v_chip, {
                                              class: _normalizeClass(["mx-1", { 'my-1': _ctx.isCellEditor }]),
                                              color: _ctx.cellField === 'tags' ? 'primary' : '',
                                              label: "",
                                              small: "",
                                              light: "",
                                              key: element.id
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.entityName(element)), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["class", "color"]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 256)),
                                    (_ctx.isCellEditor ? _ctx.value.length > 1 : _ctx.value.length > 3)
                                      ? (_openBlock(), _createBlock(_component_v_chip, {
                                          key: 0,
                                          class: "ma-1 white--text",
                                          color: "grey darken-2",
                                          label: "",
                                          small: "",
                                          light: "",
                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.show = !_ctx.state.show))
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.state.show)
                                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                                  key: 0,
                                                  small: "",
                                                  class: "mr-2"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_2
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(_ctx.state.show ? _ctx.t('General_hide') : '+' + (_ctx.isCellEditor ? _ctx.value.length - 1 : _ctx.value.length - 3) + ' ' + _ctx.t('General_others')), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    (typeof _ctx.value === 'boolean')
                                      ? (_openBlock(), _createBlock(_component_v_chip, {
                                          key: 0,
                                          class: _normalizeClass(_ctx.value ? 'text-success' : 'text-error'),
                                          label: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.UTIL.checkBoolean(_ctx.cellField, _ctx.value)), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["class"]))
                                      : (typeof _ctx.value === 'object' && _ctx.value)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 1,
                                            class: "my-1",
                                            label: "",
                                            small: "",
                                            light: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.entityName(_ctx.value)), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.value === 0 ? 0 : _ctx.UTIL.formatTableValue(_ctx.cellField, _ctx.value)), 1))
                                  ]))
      ], 16)
    ]),
    _: 1
  }))
}